module.exports = __webpack_public_path__ + "img/knight3_05.945b87f9.jpg";